import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <g transform="translate(30.000000, 27.000000)">
          <path
            d="M5.46094 21.6406V35H0.960938V0.875H13.5469C17.2812 0.875 20.2031 1.82813 22.3125 3.73438C24.4375 5.64062 25.5 8.16406 25.5 11.3047C25.5 14.6172 24.4609 17.1719 22.3828 18.9688C20.3203 20.75 17.3594 21.6406 13.5 21.6406H5.46094ZM5.46094 17.9609H13.5469C15.9531 17.9609 17.7969 17.3984 19.0781 16.2734C20.3594 15.1328 21 13.4922 21 11.3516C21 9.32031 20.3594 7.69531 19.0781 6.47656C17.7969 5.25781 16.0391 4.625 13.8047 4.57812H5.46094V17.9609Z"
            fill="currentColor"
          />
        </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
